/* eslint-disable react/prop-types */
import React, { useCallback } from "react"
import t from "prop-types"
import isNil from "lodash/isNil"

import AsyncDropdown from "components/common/input/AsyncDropdown"

export default function InvoicePicker({
  classes,
  disabled,
  onAddItem,
  fetchInvoiceData = new Promise((res) => res([])),
}) {
  const wrappedFetchInvoices = useCallback(
    async (searchText) => {
      const response = await fetchInvoiceData(searchText)
      return response.map((res) => {
        return {
          invoiceNumber: res.invoiceNumber,
          customerName: res.customerName,
          date: res.date,
          totalAmount: res.totalAmount,
          invoice: res,
        }
      })
    },
    [fetchInvoiceData]
  )

  return (
    <div className={classes.invoicePickerContainer}>
      <AsyncDropdown
        disabled={disabled}
        onChange={(newVal) => {
          if (newVal !== null) {
            onAddItem(newVal)
          }
        }}
        fetchData={wrappedFetchInvoices}
        style={{
          width: "100%",
          maxWidth: 230,
        }}
        className={classes.invoiceAutocomplete}
        disableCloseOnSelect
        // renderOption={(option) =>
        //   `${option.materialCode} (${option.description})`
        // }
        getOptionLabel={(option) =>
          isNil(option.invoiceNumber) ? "" : `${option.invoiceNumber}`
        }
        getOptionSelected={(option, val) =>
          option.invoiceNumber === val.invoiceNumber
        }
        variant="outlined"
        inputLabel="Choose Invoice Number"
      />
    </div>
  )
}

InvoicePicker.propTypes = {
  disabled: t.bool,
  onAddItem: t.func,
}

InvoicePicker.defaultProps = {
  disabled: false,
  onAddItem: () => {},
}
